import React, { ReactElement } from "react";
import Style from "./index.module.scss";
import { Icon, Tooltip } from "antd";
import { CourseWareTypeList } from "API/courseware";

interface Props {
    text: string | React.ReactChild;
    children?: ReactElement[];
    title?: ReactElement;
    size?: number;
    fileType: string;
    style?: React.CSSProperties | undefined;
    nameWidth?: string;
    nameClick?: () => void;
}
const Index = ({
    text,
    fileType,
    size = 14,
    children,
    style,
    nameClick,
    nameWidth = "100%",
    title,
    ...restProps
}: Props) => {
    function fileImg(fileType: string) {
        let img = null;
        type keyType = keyof typeof CourseWareTypeList;

        const icons: { [key: string]: string } = {
            ppt: require("./img/icon1.png"),
            word: require("./img/icon2.png"),
            excel: require("./img/icon3.png"),
            pdf: require("./img/icon5.png"),
            video: require("./img/icon4.png"),
            polyv: require("./img/icon4.png"),
            pic: require("./img/icon6.png"),
            href: require("./img/href.png"),
            txt: require("./img/txt.png"),
            compression: require("./img/compression.png")
        };

        for (let type of Object.keys(CourseWareTypeList)) {
            if (
                CourseWareTypeList[type as keyType].includes(
                    fileType?.toLowerCase()
                )
            ) {
                img = icons[type];
            }
        }
        if (img) {
            return <img src={img} alt="" style={{ width: size }} />;
        } else {
            return <Icon type="file" style={{ fontSize: size }} />;
        }
    }
    return (
        <Tooltip title={text}>
            <dl {...restProps} className={Style.item} style={style}>
                <dt style={{ maxWidth: nameWidth }}>
                    <span className={Style.name} onClick={() => nameClick?.()}>
                        {fileImg(fileType)}
                        <b>
                            {text} {title}
                        </b>
                    </span>
                </dt>
                <dd>{children}</dd>
            </dl>
        </Tooltip>
    );
};

export default Index;
